import {Component} from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';

import {RegisterStaffPage} from '../../pages/register-staff/register-staff';
import {RegisterRecruiterPage} from '../../pages/register-recruiter/register-recruiter';

@Component({
  selector: 'page-register-choose',
  templateUrl: 'register-choose.html',
})
export class RegisterChoosePage {
  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegisterChoosePage');
  }

  openPage(page: string) {
    const self = this;
    console.log(page);
    switch (page) {
      case 'staff': {
        self.navCtrl.push(RegisterStaffPage);
        break;
      }
      case 'recruiter': {
        self.navCtrl.push(RegisterRecruiterPage);
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/register-choose/register-choose.ts